module.exports = __webpack_public_path__ + "static/linkedlist-2.7-b41800da7977dea74a5ee47497a543f5.png";